export default function Go_Variable_Naming() {
  return (
    <div>
      <h1>Go_Variable_Naming </h1>
      <p>Go Variable Naming</p>
    </div>
  );
}
